var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.615 105.836C23.55 105.836 23.49 105.836 23.42 105.831C21.845 105.751 20.3 105.411 18.83 104.816C11.595 101.876 8.10501 93.6115 11.04 86.3815L47.645 22.2515C48.905 19.9715 50.815 18.0615 53.145 16.7715C59.97 12.9915 68.6 15.4765 72.375 22.2965L108.74 85.9365C109.55 87.8415 109.895 89.3915 109.98 90.9715C110.175 94.7515 108.885 98.3765 106.355 101.181C103.825 103.986 100.35 105.641 96.575 105.831L23.975 105.836H23.615Z",
    fill: "#D6E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6263 50.104C55.6263 47.694 57.5913 45.729 60.0013 45.729C62.4113 45.729 64.3763 47.694 64.3763 50.104V64.244C64.3763 66.659 62.4113 68.619 60.0013 68.619C57.5913 68.619 55.6263 66.659 55.6263 64.244V50.104ZM55.626 81.3494C55.626 78.9244 57.591 76.9494 60.001 76.9494C62.411 76.9494 64.376 78.8994 64.376 81.2944C64.376 83.7594 62.411 85.7244 60.001 85.7244C57.591 85.7244 55.626 83.7594 55.626 81.3494Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorError);
export default __webpack_public_path__ + "static/media/VectorError.1d872c8ca0c6a4affeb093ba10139cb2.svg";
export { ForwardRef as ReactComponent };